import React from "react";
import PropTypes from "prop-types";

import { Card, CardContent } from "@components/layout/Card";

import { BudgetProvider } from "./context";
import { SelectedTabForm } from "./SelectedTabForm";
import { BudgetTabs } from "./BudgetTabs";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { IncomeAndBudgetAssumptions } from "./IncomeAndBudgetAssumptions";

import { Breakdown } from "./Breakdown";

export const Budget = (props) => (
  <BudgetProvider {...props}>
    <Card className="budget">
      <SelectedTabForm {...props}>
        <Header />
        <CardContent>
          <Breakdown />
          <IncomeAndBudgetAssumptions />
          <BudgetTabs />
        </CardContent>
        <Footer />
      </SelectedTabForm>
    </Card>
  </BudgetProvider>
);

Budget.propTypes = {
  budget: PropTypes.object.isRequired,
  totalIncomeFromInvestments: PropTypes.number.isRequired,
  totalContributions: PropTypes.number.isRequired,
  totalLiabilityRepayments: PropTypes.number.isRequired,
  totalAdditionalIncomeFromInvestments: PropTypes.number.isRequired,
  totalMonthlyCashflowIncome: PropTypes.number.isRequired,
  totalMonthlyCashflowExpenses: PropTypes.number.isRequired,
  budgetCategories: PropTypes.object.isRequired,
  minOldAgePension: PropTypes.number,
  updateBudgetHandler: PropTypes.func.isRequired,
  scenarioPlanningPath: PropTypes.string,
  isRetired: PropTypes.bool.isRequired,
  filter: PropTypes.func,
};
